export enum EventsReportInputStateEnum {
  'BRAK_ZDEFINIOWANEGO_WEJSCIA' = 'BRAK_ZDEFINIOWANEGO_WEJSCIA',
  'DRZWI_ZOSTALY_OTWARTE' = 'DRZWI_ZOSTALY_OTWARTE',
  'DRZWI_NIE_ZOSTALY_OTWARTE' = 'DRZWI_NIE_ZOSTALY_OTWARTE',
}

export enum EventsReportInputStateMessageEnum {
  'BRAK_ZDEFINIOWANEGO_WEJSCIA' = 'reports.eventsReport.inputState.noDefinedInput',
  'DRZWI_ZOSTALY_OTWARTE' = 'reports.eventsReport.inputState.doorsWereOpened',
  'DRZWI_NIE_ZOSTALY_OTWARTE' = 'reports.eventsReport.inputState.doorsWereNotOpened',
}
